import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import OffCanvasMenu from "./OffCanvasMenu";
import { HiMenu, HiOutlineX } from "react-icons/hi";
import {
  serviceList,
  productList
} from "./../../data";
const Navbar = ({
  navDark,
  insurance,
  classOption,
  corporate,
  creativeAgencyOne,
  itCompany,
}) => {
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);

  useEffect(() => {
    const stickyheader = document.querySelector(".main-header");
    setHeaderTop(stickyheader.offsetTop);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };
  return (
    <>
      <header
        className={`main-header z-10 ${
          creativeAgencyOne ? "creative_agency_nav " : ""
        }  ${itCompany ? "it_company_nav " : ""}     ${
          corporate ? "header-35 position-absolute top-0 start-0 zindex-9" : ""
        }   ${navDark ? "position-absolute " : ""} w-100 ${classOption} ${
          insurance && "ins-header main-header w-100 z-10 "
        }`}
      >
        <nav
          className={`navbar navbar-expand-xl z-50  ${
            corporate ? "affix" : ""
          } ${navDark ? "navbar-dark " : "navbar-light"} sticky-header ${
            scroll > headerTop ? "affix" : ""
          }`}
        >
          <div className="container d-flex align-items-center justify-content-lg-between position-relative ">
            <div className="d-flex flex-column align-items-start">
              <Link to="/">
                {scroll > headerTop || !navDark || itCompany ? (
                  <img
                    width={150}
                    height={50}
                    src="assets/logo/name-gold-blue-tb.png"
                    alt="logo"
                    className="img-fluid logo-color "
                  />
                ) : (
                  <img
                    width={150}
                    height={50}
                    src="assets/logo/name-gold-white-tb.png"
                    alt="logo"
                    className="img-fluid logo-white "
                  />
                )}
              </Link>
              {scroll > headerTop || !navDark || itCompany ? (
                <span
                  style={{ color: "#07034D", marginTop: "-5px" }}
                  className="fs-10 fw-bolder ms-2"
                >
                  Empowering Businesses with Next-Gen Technology
                </span>
              ) : (
                <span
                  style={{ color: "#FFD700", marginTop: "-5px" }}
                  className="fs-10 fw-bolder ms-2"
                >
                  Empowering Businesses with Next-Gen Technology
                </span>
              )}
            </div>
            <button
              className="navbar-toggler position-absolute right-0 border-0"
              id="#offcanvasWithBackdrop"
              role="button"
            >
              <span
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasWithBackdrop"
                aria-controls="offcanvasWithBackdrop"
              >
                <HiMenu />
              </span>
            </button>
            <div className="clearfix"></div>
            <div className="collapse navbar-collapse justify-content-end me-3">
              <ul className="nav col-12 col-md-auto justify-content-center main-menu">
                <li className="nav-item dropdown">
                  <Link to="/" className="nav-link">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about-us" className="nav-link">
                    About
                  </Link>
                </li>
                <li className="dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Services
                  </a>
                  <div className="dropdown-menu border-0 rounded-custom shadow py-0 bg-white">
                    <div className="dropdown-grid rounded-custom">
                      <div
                        className="dropdown-grid-item "
                        style={{ width: "20vw" }}
                      >
                        {serviceList.map((serviceListItem, i) => (
                          <div key={i + 1} className="d-flex">
                            <span className="mt-1">
                              {" "}
                              <img
                                width={30}
                                height={50}
                                src={serviceListItem.icon}
                                alt="logo"
                                className="img-fluid ps-2"
                              />
                            </span>
                            <Link
                              to={serviceListItem.href}
                              className="dropdown-link px-0"
                            >
                              <span className="drop-title mb-0">
                                {serviceListItem.title}{" "}
                              </span>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </li>
                <li className="dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Products
                  </a>
                  <div className="dropdown-menu border-0 rounded-custom shadow py-0 bg-white position-absolute bottom-0 start-50">
                    <div
                      className="dropdown-grid rounded-custom"
                      // style={{ width: "22vw" }}
                    >
                      <div
                        className="dropdown-grid-item product-dropdown-width"
                        style={{ width: "22vw" }}
                      >
                        <div className=" text-center drop-title fs-6">
                          Automotive
                        </div>
                        {/* <hr /> */}
                        {productList.map((productListItem, i) => (
                          <div className="d-flex">
                            <div key={i + 1}>
                              <Link
                                to={productListItem.href}
                                className="dropdown-link px-0"
                                onClick={(e) => {
                                  if (productListItem.title === "ABMS") {
                                  } else {
                                    // e.preventDefault(); // Prevent default navigation behavior
                                    // window.open(productListItem.href, '_blank'); // Open in a new tab
                                  }
                                }}
                              >
                                <span className="demo-list text-secondary rounded text-white fw-bold mb-3">
                                  <img
                                    width={121}
                                    height={50}
                                    src={productListItem.icon}
                                    alt="logo"
                                    className="img-fluid ps-2"
                                  />
                                </span>
                                <span
                                  className="drop-title mb-0 "
                                  title={productListItem.onHoverText}
                                >
                                  {productListItem.title}{" "}
                                  <span className="ail-highlighted-text">
                                    {productListItem.onHoverText}
                                  </span>{" "}
                                  <br />
                                  <p className="subtitle-font">
                                    {productListItem.subtitle}
                                    {""}
                                  </p>
                                </span>
                              </Link>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="action-btns text-end me-5 me-lg-0 d-none d-md-block d-lg-block">
              {/* <Link
                to="/login"
                className="btn btn-link text-decoration-none me-2"
              >
                Sign In
              </Link> */}
              <Link
                to="/contact-us"
                className={
                  insurance ? "ins-btn ins-primary-btn" : "btn btn-primary"
                }
              >
                Become Partner
              </Link>
            </div>

            <div
              className="offcanvas offcanvas-end d-xl-none"
              tabIndex="-1"
              id="offcanvasWithBackdrop"
            >
              <div className="offcanvas-header d-flex align-items-center mt-4">
                <Link
                  to="/"
                  className="d-flex align-items-center mb-md-0 text-decoration-none"
                >
                  <img
                    width={121}
                    height={50}
                    src="/assets/logo/name-gold-blue-tb.png"
                    alt="logo"
                    className="img-fluid ps-2"
                  />
                </Link>
                <button
                  type="button"
                  className="close-btn text-danger"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <HiOutlineX />
                </button>
              </div>

              <OffCanvasMenu />
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Navbar;
